<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M2.42166 14.5874L4.44755 3.09799C4.60739 2.1915 5.47182 1.58622 6.37831 1.74606L16.2264 3.48254C17.1329 3.64238 17.7381 4.50681 17.5783 5.4133L15.5524 16.9027C15.3926 17.8092 14.5281 18.4145 13.6216 18.2547L3.77359 16.5182C2.8671 16.3584 2.26182 15.4939 2.42166 14.5874Z"
      :stroke="stroke"
      stroke-width="1.5"
    />
    <path
      d="M7.44086 5.31812L14.0063 6.47576"
      :stroke="stroke"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M6.86206 8.60107L13.4274 9.75874"
      :stroke="stroke"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M6.2832 11.884L10.3866 12.6076"
      :stroke="stroke"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M24 25.3418L24.0083 25.3325"
      :stroke="stroke"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.8333 28.1666V15.8333C19.8333 15.5571 20.0572 15.3333 20.3333 15.3333H27.6666C27.9428 15.3333 28.1666 15.5571 28.1666 15.8333V28.1666C28.1666 28.4428 27.9428 28.6666 27.6666 28.6666H20.3333C20.0572 28.6666 19.8333 28.4428 19.8333 28.1666Z"
      :stroke="stroke"
      stroke-width="1.5"
    />
  </svg>
</template>

<script>
import {DEFAULT_BRAND_SECONDARY_COLOR} from '../constants';

export default {
  inject: ['getBrandSecondaryBackground'],
  computed: {
    stroke() {
      const stroke = this.getBrandSecondaryBackground();
      console.log('brand primary background: ', stroke);
      return stroke || DEFAULT_BRAND_SECONDARY_COLOR;
    },
  },
};
</script>
